<template>
  <div>
    <b-container fluid class="mt-3">
      <b-row>
        <b-col v-for="league in leagues" :key="league.id" cols="6" class="mt-3">
          <b-card
            bg-variant="dark"
            class="text-light h-100"
            border-variant="success"
          >
            <b-card-title>{{ league.name }}</b-card-title>
            <b-card-text>
              Starting: {{ formatDate(league.start_date) }}
              <br />
              <div
                v-if="league.name == 'Standard' || league.name == 'Hardcore'"
              >
                Ending: /
              </div>

              <div v-else>
                {{
                  league.end_date.includes("2025")
                    ? "Estimated ending: " + calcEndDate(league.start_date)
                    : "Ending: " + formatDate(league.end_date)
                }}
              </div>
            </b-card-text>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      leagues: [],
    };
  },
  mounted() {
    var subdomain = window.location.host.split(".")[1]
      ? window.location.host.split(".")[0]
      : false;
    if (subdomain === "private") {
      //get private leagues
      axios.get("https://api.poe.watch/privateLeagues").then((leagues) => {
        this.leagues = leagues.data;
        return;
      });
    } else {
      axios.get("https://api.poe.watch/leagues").then((leagues) => {
        this.leagues = leagues.data;
      });
    }
  },
  methods: {
    formatDate(date) {
      var d = new Date(date);
      var curr_date = d.getDate();
      var curr_month = d.getMonth() + 1; //Months are zero based
      var curr_year = d.getFullYear();
      var time =
        d.getUTCHours() +
        ":" +
        d.getUTCMinutes() +
        ":" +
        d.getUTCSeconds() +
        "UTC";
      return curr_date + "." + curr_month + "." + curr_year + " " + time;
    },
    calcEndDate(date) {
      var d = new Date(date);
      var newDate = new Date(d.setMonth(d.getMonth() + 3));
      return this.formatDate(newDate);
    },
  },
};
</script>

<style></style>
